import React from 'react';
import { useNightMode } from '../../../contexts/NightModeContext';
import { images } from '../../../assets/images';

const Footer: React.FC = () => {
  const { isNightMode } = useNightMode();

  return (
    <footer
      id="workspace-footer"
      className={`position-relative mt-5 pt-4 pb-4 border-top text-center d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3 px-3 px-md-4 ${
        isNightMode ? 'border-white border-opacity-10 text-white-50' : 'border-secondary-subtle text-secondary'
      }`}
      style={{ position: "relative", zIndex: 20, fontSize: 13, fontFamily: "sans-serif", width: "100%" }}
    >
      <div className="d-flex align-items-center gap-2 user-select-none font-medium">
        <img
          src={isNightMode ? images.eventox_dark_logo : images.eventox_light_logo}
          alt="Eventox Logo"
          style={{ height: 12, objectFit: 'contain' }}
        />
        <span className="fw-bold text-pink">/</span>
        <span className={isNightMode ? "text-white-50" : "text-secondary"}>Studios &copy; {new Date().getFullYear()}</span>
      </div>
      <div className="d-flex align-items-center gap-3 flex-wrap justify-content-center">
        <span className="cursor-pointer text-hover-white">Reconciliation Ledgers</span>
        <span>&bull;</span>
        <span className="cursor-pointer text-hover-white">Stripe Gateway</span>
        <span>&bull;</span>
        <span className="cursor-pointer text-hover-white">Service Level Agreement</span>
      </div>
    </footer>
  );
};

export default Footer;